import React, { useContext, useEffect } from "react";
import { BsFillLockFill, BsThreeDotsVertical } from "react-icons/bs";
import { AiOutlineCaretDown, AiFillCaretUp } from "react-icons/ai";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import ParameterContext from "../../context/parameter/parameterContext";
import VTradingContext from "../../context/vTrading/VTradingContext";
import CryptoContext from "../../context/crypto/cryptoContext";
import NumberFormat from "react-number-format";
import { formatPrice } from "../../helpers/format";
import moment from "moment";
import VtradingDropdown from "../../components/VtradingDropdown";
import SellAlert from "../../components/SellAlert";
import Modal from "../../components/Modal";
import _ from "lodash";
import Price from "../../components/Price";
import ReactTooltip from "react-tooltip";
const Vtrading = ({ history }) => {
  const {
    setColumnName,
    columnName,
    vtButton,
    activePortfolio,
    setActivePortfolioPage,
    vtradingModal,
  } = useContext(ParameterContext);
  const {
    vtradingAlertModal,

    setTotalInvAmount,
    setTotalCurrentAmount,
    currentAmount,
    setTotalNetPL,
    invAmount,
    openOrders,
    position,
    historyOrders,
  } = useContext(VTradingContext);
  const {
    cryptoData,

    sortGlobalTickerByPrice,
    order,
    sortGlobalTickerBy24h,

    sortGlobalTickerBy7d,
    sortGlobalTickerByName,
    sortGlobalTickerByMarketCap,

    livePriceData,
    exchangeRate,
    currencySymbol,
  } = useContext(CryptoContext);
  // const [close, setClose] = useState(true);

  useEffect(() => {
    if (position?.length > 0 && vtButton === "position") {
      setTotalInvAmount(_.sum(position.map((c) => c.invAmount)));
    }

    if (position?.length > 0 && vtButton === "position") {
      if (livePriceData) {
        setTotalCurrentAmount(
          _.sum(
            position.map(
              (c) => c.amount * (livePriceData[c.symbol] * exchangeRate)
            )
          )
        );
      } else {
        // position.map((c) =>
        //   console.log(cryptoData.filter((d) => d.symbol === c.symbol)[0].price)
        // );
        setTotalCurrentAmount(
          _.sum(
            position.map(
              (c) =>
                c.amount *
                cryptoData.filter((d) => d.symbol === c.symbol)[0].price
            )
          )
        );
      }
    }
    if (position?.length === 0) {
      setTotalInvAmount(0);
      setTotalCurrentAmount(0);
      setTotalNetPL(0);
    }
    //eslint-disable-next-line
  }, [position, livePriceData, activePortfolio]);

  // useEffect(() => {
  // }, [livePriceData, position]);
  useEffect(() => {
    if (invAmount && currentAmount) {
      setTotalNetPL(currentAmount - invAmount);
    }
    //eslint-disable-next-line
  }, [invAmount, currentAmount]);

  const handleClick = (id) => {
    history?.push(`/cryptos/${id}`);
  };

  return (
    <div className="Vtrading">
      <div className="VtradingScreen__container">
        {vtradingModal && <Modal />}
        {vtradingAlertModal && <SellAlert />}

        <div className="VTradingScreen2__container">
          <div
            className={
              activePortfolio > 1 ? "Vtrading__next__active" : "Vtrading__next"
            }
            onClick={() =>
              activePortfolio > 1 && setActivePortfolioPage(activePortfolio - 1)
            }
          >
            <IoIosArrowBack size={30} />
          </div>

          <div
            className={
              activePortfolio < 3 ? "Vtrading__next__active" : "Vtrading__next"
            }
            onClick={() =>
              activePortfolio < 3 && setActivePortfolioPage(activePortfolio + 1)
            }
          >
            <IoIosArrowForward size={30} />
          </div>
          <div
            className="VtradingScreen2__TableContainer"
            style={{ background: "#EFF2F5" }}
          >
            {vtButton === "position" ? (
              <table className="Home__MainTable">
                <thead>
                  <tr>
                    <th></th>

                    <th style={{ textAlign: "left" }}>
                      <div className="Home__MainTable-th">
                        <div
                          style={{
                            color: "white",
                            justifyContent: "flex-start",
                          }}
                          className="Home__MainTable__pct"
                        >
                          <div style={{ cursor: "pointer" }}>Coin</div>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div className="Home__MainTable-th">
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          &nbsp;
                          <div
                            onClick={() => {
                              sortGlobalTickerByPrice();
                              setColumnName("price");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            Quantity
                          </div>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div className="Home__MainTable-th">
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          <div
                            onClick={() => {
                              sortGlobalTickerBy24h();
                              setColumnName("24h%");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            Total Investment
                          </div>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div className="Home__MainTable-th">
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          &nbsp;
                          <div
                            onClick={() => {
                              sortGlobalTickerBy7d();
                              setColumnName("7d%");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            Average Price
                          </div>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div className="Home__MainTable-th">
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          <div
                            onClick={() => {
                              sortGlobalTickerByMarketCap();
                              setColumnName("marketcap");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            Current Price
                          </div>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div className="Home__MainTable-th">
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          <div style={{ cursor: "pointer" }}>P & L</div>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div className="Home__MainTable-th">
                        <div>
                          <p>% Ch</p>
                        </div>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {position && position.length > 0 ? (
                    position.map((c) => (
                    
                        <tr key={c._id} className="Home__MainTable__link">
                          <td style={{ textAlign: "left" }}>
                            <VtradingDropdown
                              amount={c.qtyAvailableToSell}
                              price={formatPrice(c.invAmount / c.amount)}
                              id={c.symbol}
                              marketPrice={
                                livePriceData
                                  ? formatPrice(livePriceData[c.symbol])
                                  : formatPrice(c.price)
                              }
                              type="position"
                            />
                          </td>

                          <td style={{ textAlign: "left" }}>
                            <div className="Home__MainTable-td">
                              <p
                                style={{
                                  marginRight: "5px",
                                  whiteSpace: "nowrap",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleClick(c.id)}
                              >
                                {c.symbol}
                              </p>
                            </div>
                          </td>

                          <td style={{ textAlign: "left" }}>
                            <div
                              className="Home__MainTable-td"
                              // style={{flexDirection: "column",alignItems:"flex-start"}}
                            >
                              <p
                                style={{
                                  marginRight: "5px",
                                  whiteSpace: "nowrap",
                                  cursor: "pointer",
                                }}
                              >
                                {formatPrice(c.qtyAvailableToSell)}
                                {c.lockamount > 0 && (
                                  <>
                                    (
                                    <BsFillLockFill
                                      style={{ color: "#8d0782" }}
                                      data-tip="Lock Amount"
                                    />
                                    <span data-tip="Lock Amount">
                                      {formatPrice(c.lockamount)}
                                      <ReactTooltip
                                        place="top"
                                        effect="float"
                                        style={{ color: "#8d0782" }}
                                      />
                                    </span>
                                    )
                                  </>
                                )}
                              </p>
                            </div>
                          </td>

                          <td>
                            <div
                              className="Home__MainTable-td"
                              style={{
                                whiteSpace: "nowrap",
                                cursor: "pointer",
                              }}
                              onClick={() => handleClick(c.id)}
                            >
                              <div>
                                <NumberFormat
                                  value={formatPrice(
                                    c.invAmount / exchangeRate
                                  )}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={currencySymbol}
                                />
                              </div>
                            </div>
                          </td>

                          <td>
                            <div
                              className="Home__MainTable-td"
                              style={{
                                whiteSpace: "nowrap",
                                cursor: "pointer",
                              }}
                              onClick={() => handleClick(c.id)}
                            >
                              <div>
                                <NumberFormat
                                  value={formatPrice(
                                    c.invAmount / c.amount / exchangeRate
                                  )}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={currencySymbol}
                                />
                              </div>
                            </div>
                          </td>

                          <Price
                            id={c.symbol}
                            item={
                              cryptoData && cryptoData.length > 0
                                ? cryptoData.filter(
                                    (d) => d.symbol === c.symbol
                                  )[0].price
                                : null
                            }
                            property="price"
                            style2={{
                              justifyContent: "flex-start",
                              whiteSpace: "nowrap",
                              cursor: "pointer",
                            }}
                            style1={{ textAlign: "right" }}
                          />

                          <td>
                            <div
                              className="Home__MainTable-td"
                              style={{
                                whiteSpace: "nowrap",
                                cursor: "pointer",
                              }}
                              onClick={() => handleClick(c.id)}
                            >
                              <div>
                                {c.invAmount / exchangeRate -
                                  (livePriceData
                                    ? livePriceData[c.symbol]
                                    : cryptoData && cryptoData.length > 0
                                    ? cryptoData.filter(
                                        (d) => d.symbol === c.symbol
                                      )[0].price / exchangeRate
                                    : null) *
                                    c.amount <
                                0 ? (
                                  <>+</>
                                ) : (
                                  <>-</>
                                )}
                                <NumberFormat
                                  value={formatPrice(
                                    Math.abs(
                                      c.invAmount / exchangeRate -
                                        (livePriceData
                                          ? livePriceData[c.symbol]
                                          : cryptoData && cryptoData.length > 0
                                          ? cryptoData.filter(
                                              (d) => d.symbol === c.symbol
                                            )[0].price / exchangeRate
                                          : null) *
                                          c.amount
                                    )
                                  )}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={currencySymbol}
                                />
                              </div>
                            </div>
                          </td>

                          <td>
                            <div
                              style={{
                                justifyContent: "flex-start",
                                color:
                                  Number(
                                    c.invAmount / exchangeRate -
                                      (livePriceData
                                        ? livePriceData[c.symbol]
                                        : cryptoData && cryptoData.length > 0
                                        ? cryptoData.filter(
                                            (d) => d.symbol === c.symbol
                                          )[0].price / exchangeRate
                                        : null) *
                                        c.amount
                                  ) < 0
                                    ? "rgba(69, 170, 67, 1)"
                                    : "rgba(233, 56, 72, 1)",
                              }}
                              className="Home__MainTable__pct"
                            >
                              {c.invAmount / exchangeRate -
                                (livePriceData
                                  ? livePriceData[c.symbol]
                                  : cryptoData && cryptoData.length > 0
                                  ? cryptoData.filter(
                                      (d) => d.symbol === c.symbol
                                    )[0].price / exchangeRate
                                  : null) *
                                  c.amount <
                              0 ? (
                                <AiFillCaretUp className="Home__MainTable__pcticon" />
                              ) : (
                                <>
                                  <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                                </>
                              )}
                              <NumberFormat
                                value={formatPrice(
                                  (Math.abs(
                                    c.invAmount / exchangeRate -
                                      (livePriceData
                                        ? livePriceData[c.symbol]
                                        : cryptoData && cryptoData.length > 0
                                        ? cryptoData.filter(
                                            (d) => d.symbol === c.symbol
                                          )[0].price / exchangeRate
                                        : null) *
                                        c.amount
                                  ) /
                                    (c.invAmount / exchangeRate)) *
                                    100
                                )}
                                displayType={"text"}
                                thousandSeparator={true}
                              />
                              %
                            </div>
                          </td>
                        </tr>
                    
                    ))
                  ) : (
                    <></>
                  )}
                </tbody>
              </table>
            ) : vtButton === "history" ? (
              <table className="Home__MainTable">
                <thead>
                  <tr>
                    <th></th>
                    <th style={{ textAlign: "left" }}>
                      <div className="Home__MainTable-th">
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          {columnName &&
                          columnName === "name" &&
                          order === 1 ? (
                            <AiFillCaretUp className="Home__MainTable__pcticon" />
                          ) : columnName &&
                            columnName === "name" &&
                            order === 0 ? (
                            <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                          ) : (
                            <></>
                          )}
                          &nbsp;
                          <div
                            onClick={() => {
                              sortGlobalTickerByName();
                              setColumnName("name");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            Type
                          </div>
                        </div>
                      </div>
                    </th>
                    <th style={{ textAlign: "left" }}>
                      <div className="Home__MainTable-th">
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          {columnName &&
                          columnName === "name" &&
                          order === 1 ? (
                            <AiFillCaretUp className="Home__MainTable__pcticon" />
                          ) : columnName &&
                            columnName === "name" &&
                            order === 0 ? (
                            <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                          ) : (
                            <></>
                          )}
                          &nbsp;
                          <div
                            onClick={() => {
                              sortGlobalTickerByName();
                              setColumnName("name");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            Coin
                          </div>
                        </div>
                      </div>
                    </th>

                    <th>
                      <div className="Home__MainTable-th">
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          {columnName &&
                          columnName === "price" &&
                          order === 1 ? (
                            <AiFillCaretUp className="Home__MainTable__pcticon" />
                          ) : columnName &&
                            columnName === "price" &&
                            order === 0 ? (
                            <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                          ) : (
                            <></>
                          )}
                          &nbsp;
                          <div
                            onClick={() => {
                              sortGlobalTickerByPrice();
                              setColumnName("price");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            Quantity
                          </div>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div className="Home__MainTable-th">
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          {columnName &&
                          columnName === "24h%" &&
                          order === 1 ? (
                            <AiFillCaretUp className="Home__MainTable__pcticon" />
                          ) : columnName &&
                            columnName === "24h%" &&
                            order === 0 ? (
                            <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                          ) : (
                            <></>
                          )}
                          &nbsp;
                          <div
                            onClick={() => {
                              sortGlobalTickerBy24h();
                              setColumnName("24h%");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            Price
                          </div>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div className="Home__MainTable-th">
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          {columnName && columnName === "7d%" && order === 1 ? (
                            <AiFillCaretUp className="Home__MainTable__pcticon" />
                          ) : columnName &&
                            columnName === "7d%" &&
                            order === 0 ? (
                            <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                          ) : (
                            <></>
                          )}
                          &nbsp;
                          <div
                            onClick={() => {
                              sortGlobalTickerBy7d();
                              setColumnName("7d%");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            Total Val
                          </div>
                        </div>
                      </div>
                    </th>

                    <th>
                      <div className="Home__MainTable-th">
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          {columnName &&
                          columnName === "volumeIn24h" &&
                          order === 1 ? (
                            <AiFillCaretUp className="Home__MainTable__pcticon" />
                          ) : columnName &&
                            columnName === "volumeIn24h" &&
                            order === 0 ? (
                            <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                          ) : (
                            <></>
                          )}
                          &nbsp;
                          <div style={{ cursor: "pointer" }}>Time</div>
                        </div>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {historyOrders && historyOrders.length > 0 ? (
                    historyOrders.map((c) => (
                        <tr key={c._id} className="Home__MainTable__link">
                          <td style={{ textAlign: "left" }}>
                            <div className="Home__MainTable-td">
                              <BsThreeDotsVertical />
                            </div>
                          </td>

                          <td style={{ textAlign: "left" }}>
                            <div className="Home__MainTable-td">
                              <p
                                style={{
                                  marginRight: "5px",
                                  whiteSpace: "nowrap",
                                  cursor: "pointer",
                                  color:
                                    c.type === "buy"
                                      ? "rgba(69, 170, 67, 1)"
                                      : "rgba(233, 56, 72, 1)",
                                }}
                              >
                                {c.type}
                              </p>
                            </div>
                          </td>

                          <td style={{ textAlign: "left" }}>
                            <div className="Home__MainTable-td">
                              <p
                                style={{
                                  marginRight: "5px",
                                  whiteSpace: "nowrap",
                                  cursor: "pointer",
                                }}
                              >
                                {c.symbol}
                              </p>
                            </div>
                          </td>

                          <td style={{ textAlign: "left" }}>
                            <div className="Home__MainTable-td">
                              <p
                                style={{
                                  marginRight: "5px",
                                  whiteSpace: "nowrap",
                                  cursor: "pointer",
                                }}
                              >
                                {c.amount}
                              </p>
                            </div>
                          </td>

                          <td>
                            <div
                              className="Home__MainTable-td"
                              style={{
                                whiteSpace: "nowrap",
                                cursor: "pointer",
                              }}
                              onClick={() => handleClick(c.id)}
                            >
                              <div>
                                <NumberFormat
                                  value={formatPrice(c.price / exchangeRate)}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={currencySymbol}
                                />
                              </div>
                            </div>
                          </td>

                          <td>
                            <div
                              className="Home__MainTable-td"
                              style={{
                                whiteSpace: "nowrap",
                                cursor: "pointer",
                              }}
                              onClick={() => handleClick(c.id)}
                            >
                              <div>
                                <NumberFormat
                                  value={formatPrice(c.total / exchangeRate)}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={currencySymbol}
                                />
                              </div>
                            </div>
                          </td>

                          <td>
                            <div
                              className="Home__MainTable-td"
                              style={{
                                whiteSpace: "nowrap",
                                cursor: "pointer",
                              }}
                              onClick={() => handleClick(c.id)}
                            >
                              <div>
                                {moment(c.created_at).format(
                                  "MMMM Do YYYY, h:mm:ss a"
                                )}
                              </div>
                            </div>
                          </td>
                        </tr>
        
                    ))
                  ) : (
                    <></>
                  )}
                </tbody>
              </table>
            ) : (
              <table className="Home__MainTable">
                <thead>
                  <tr>
                    <th></th>
                    <th style={{ textAlign: "left" }}>
                      <div className="Home__MainTable-th">
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          {columnName &&
                          columnName === "name" &&
                          order === 1 ? (
                            <AiFillCaretUp className="Home__MainTable__pcticon" />
                          ) : columnName &&
                            columnName === "name" &&
                            order === 0 ? (
                            <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                          ) : (
                            <></>
                          )}
                          &nbsp;
                          <div
                            onClick={() => {
                              sortGlobalTickerByName();
                              setColumnName("name");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            Type
                          </div>
                        </div>
                      </div>
                    </th>
                    <th style={{ textAlign: "left" }}>
                      <div className="Home__MainTable-th">
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          {columnName &&
                          columnName === "name" &&
                          order === 1 ? (
                            <AiFillCaretUp className="Home__MainTable__pcticon" />
                          ) : columnName &&
                            columnName === "name" &&
                            order === 0 ? (
                            <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                          ) : (
                            <></>
                          )}
                          &nbsp;
                          <div
                            onClick={() => {
                              sortGlobalTickerByName();
                              setColumnName("name");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            Coin
                          </div>
                        </div>
                      </div>
                    </th>

                    <th>
                      <div className="Home__MainTable-th">
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          {columnName &&
                          columnName === "price" &&
                          order === 1 ? (
                            <AiFillCaretUp className="Home__MainTable__pcticon" />
                          ) : columnName &&
                            columnName === "price" &&
                            order === 0 ? (
                            <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                          ) : (
                            <></>
                          )}
                          &nbsp;
                          <div
                            onClick={() => {
                              sortGlobalTickerByPrice();
                              setColumnName("price");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            Quantity
                          </div>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div className="Home__MainTable-th">
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          {columnName &&
                          columnName === "24h%" &&
                          order === 1 ? (
                            <AiFillCaretUp className="Home__MainTable__pcticon" />
                          ) : columnName &&
                            columnName === "24h%" &&
                            order === 0 ? (
                            <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                          ) : (
                            <></>
                          )}
                          &nbsp;
                          <div
                            onClick={() => {
                              sortGlobalTickerBy24h();
                              setColumnName("24h%");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            Total Investment
                          </div>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div className="Home__MainTable-th">
                        <div
                          style={{
                            color: "white",
                          }}
                          className="Home__MainTable__pct"
                        >
                          {columnName && columnName === "7d%" && order === 1 ? (
                            <AiFillCaretUp className="Home__MainTable__pcticon" />
                          ) : columnName &&
                            columnName === "7d%" &&
                            order === 0 ? (
                            <AiOutlineCaretDown className="Home__MainTable__pcticon" />
                          ) : (
                            <></>
                          )}
                          &nbsp;
                          <div
                            onClick={() => {
                              sortGlobalTickerBy7d();
                              setColumnName("7d%");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            Trigger Price
                          </div>
                        </div>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {openOrders && openOrders.length > 0 ? (
                    openOrders.map((c) => (
                    
                        <tr key={c._id} className="Home__MainTable__link">
                          <td style={{ textAlign: "left" }}>
                            <div className="Home__MainTable-td">
                              <VtradingDropdown
                                amount={c.qtyAvailableToSell}
                                price={formatPrice(c.invAmount / c.amount)}
                                id={c.symbol}
                                totalInvestedForEdit={c.total}
                                marketPrice={c.price}
                                type="openOrder"
                                orderType={c.type}
                                orderId={c._id}
                              />
                            </div>
                          </td>

                          <td style={{ textAlign: "left" }}>
                            <div className="Home__MainTable-td">
                              <p
                                style={{
                                  marginRight: "5px",
                                  whiteSpace: "nowrap",
                                  cursor: "pointer",
                                  color:
                                    c.type === "buy"
                                      ? "rgba(69, 170, 67, 1)"
                                      : "rgba(233, 56, 72, 1)",
                                }}
                              >
                                {c.type}
                              </p>
                            </div>
                          </td>

                          <td style={{ textAlign: "left" }}>
                            <div className="Home__MainTable-td">
                              <p
                                style={{
                                  marginRight: "5px",
                                  whiteSpace: "nowrap",
                                  cursor: "pointer",
                                }}
                              >
                                {c.symbol}
                              </p>
                            </div>
                          </td>

                          <td style={{ textAlign: "left" }}>
                            <div className="Home__MainTable-td">
                              <p
                                style={{
                                  marginRight: "5px",
                                  whiteSpace: "nowrap",
                                  cursor: "pointer",
                                }}
                              >
                                {c.amount}
                              </p>
                            </div>
                          </td>

                          <td>
                            <div
                              className="Home__MainTable-td"
                              style={{
                                whiteSpace: "nowrap",
                                cursor: "pointer",
                              }}
                              onClick={() => handleClick(c.id)}
                            >
                              <div>
                                <NumberFormat
                                  value={formatPrice(c.total / exchangeRate)}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={currencySymbol}
                                />
                              </div>
                            </div>
                          </td>

                          <td>
                            <div
                              className="Home__MainTable-td"
                              style={{
                                whiteSpace: "nowrap",
                                cursor: "pointer",
                              }}
                              onClick={() => handleClick(c.id)}
                            >
                              <div>
                                <NumberFormat
                                  value={formatPrice(c.price / exchangeRate)}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={currencySymbol}
                                />
                              </div>
                            </div>
                          </td>
                        </tr>
                  
                    ))
                  ) : (
                    <></>
                  )}
                </tbody>
              </table>
            )}
          </div>
        </div>

        {/*<div className="VtradingScreen2__Footer">
          <div>&nbsp;</div>
          <div className="VtradingScreen2__buttons__group">
            <button className="SingleCrypto__grid__compare__button">
              Expert’s Portfolios
            </button>

            <button className="SingleCrypto__grid__moreinfo__button">
              Take Portfolio Tour
            </button>
          </div>
       
        </div> */}
      </div>
    </div>
  );
};

export default Vtrading;
